<template>
  <section class="landing-hero">
    <Media
      class="landing-hero__media"
      :images="heroImages"
      :cover="true"
      :eager="true"
      :cover-position="coverPosition"
    />
    <div class="landing-hero__overlay"></div>
    <div class="landing-hero__content">
      <p v-if="eyebrow" class="landing-hero__eyebrow">{{ eyebrow }}</p>
      <h1 class="landing-hero__title">
        <span>{{ title }}</span>
        <em v-if="emphasizedTitle">{{ emphasizedTitle }}</em>
      </h1>
      <p v-if="description" class="landing-hero__description">
        {{ description }}
      </p>
      <Button
        v-if="buttonText && buttonLink"
        class="landing-hero__button"
        theme="white"
        tag="a"
        :href="buttonLink"
      >
        {{ buttonText }}
      </Button>
    </div>
  </section>
</template>

<script>
import Media from "@/components/Media.vue";
import Button from "@/components/Button.vue";

export default {
  name: "LandingHero",
  components: {
    Media,
    Button,
  },
  props: {
    eyebrow: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "WELCOME TO THE",
    },
    emphasizedTitle: {
      type: String,
      default: "STYLING SERIES",
    },
    description: {
      type: String,
      default:
        "From golden hour dinners to long weekend escapes - search by item or occasion, or browse every series below.",
    },
    buttonText: {
      type: String,
      default: "",
    },
    buttonLink: {
      type: String,
      default: "",
    },
    coverPosition: {
      type: String,
      default: "top center",
    },
    images: {
      type: Object,
      default: () => ({
        smallMedia:
          "https://cdn.shopify.com/s/files/1/0942/9062/files/390_Editorial_-_Section_2.jpg?v=1778151206",
        mediumMedia:
          "https://cdn.shopify.com/s/files/1/0942/9062/files/390_Editorial_-_Section_2.jpg?v=1778151206",
        largeMedia:
          "https://cdn.shopify.com/s/files/1/0942/9062/files/Hero_Image_1.jpg?v=1778151203",
        altText: "Style Series hero",
      }),
    },
  },
  computed: {
    heroImages() {
      return {
        smallMedia: this.images?.smallMedia || "",
        mediumMedia: this.images?.mediumMedia || this.images?.smallMedia || "",
        largeMedia:
          this.images?.largeMedia ||
          this.images?.mediumMedia ||
          this.images?.smallMedia ||
          "",
        altText: this.images?.altText || "Style Series hero",
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.landing-hero {
  position: relative;
  min-height: 844px;
  background: #f3f3f3;

  @include respond-above(md) {
    min-height: 900px;
  }
}

.landing-hero__media {
  position: absolute;
  inset: 0;
}

.landing-hero__overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(
      90deg,
      rgba(0, 0, 0, 0.2) 0%,
      rgba(0, 0, 0, 0.2) 100%
    ),
    linear-gradient(180deg, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0.75) 100%);

  @include respond-above(md) {
    background: linear-gradient(
        90deg,
        rgba(0, 0, 0, 0.2) 0%,
        rgba(0, 0, 0, 0.2) 100%
      ),
      linear-gradient(180deg, rgba(0, 0, 0, 0) 56.8%, rgba(0, 0, 0, 0.75) 100%);
  }
}

.landing-hero__content {
  position: relative;
  z-index: 1;
  color: #fff;
  min-height: 844px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  text-align: left;
  gap: 16px;
  width: 100%;
  max-width: 894px;
  margin: 0 auto;
  padding: 80px 20px;

  @include respond-above(md) {
    min-height: 900px;
    gap: 20px;
    padding: 120px 20px;
  }
}

.landing-hero__eyebrow {
  @include utility-label(11px);
  letter-spacing: 0.04em;
  text-transform: uppercase;
  margin: 0;
}

.landing-hero__title {
  @include editorial-headline(34px);
  margin: 0;
  line-height: 1;
  text-transform: uppercase;
  max-width: 720px;

  span,
  em {
    display: block;
  }

  em {
    font-style: italic;
    font-weight: inherit;
    margin-left: 0;
  }

  @include respond-above(md) {
    @include editorial-headline(64px);
    max-width: 894px;
  }
}

.landing-hero__description {
  @include editorial-body(18px);
  margin: 0;
  max-width: 660px;
  overflow-wrap: anywhere;
  line-height: 1.5;
}

.landing-hero__button {
  margin-top: 8px;
}
</style>
